"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFlagOverrides = void 0;
const react_1 = require("react");
const useFlagOverrides = () => {
    const [overrides, setOverrides] = (0, react_1.useState)({});
    const setFlagOverride = (flagKey, flagValue) => {
        setOverrides({
            ...overrides,
            [flagKey]: flagValue
        });
    };
    return [overrides, setFlagOverride];
};
exports.useFlagOverrides = useFlagOverrides;
//# sourceMappingURL=useFlagOverrides.js.map